import type { TermsBlock as TermsBlockType } from "@/types";
import { renderMarkdown } from "@/lib/markdown";

/**
 * Terms — a native <details>/<summary> accordion (spec §5.6): keyboard- and
 * screen-reader-accessible with zero JS, CD styling, default open.
 */
export function TermsBlock({ block }: { block: TermsBlockType }) {
  const html = renderMarkdown(block.props.body_md);
  return (
    <section className="block block--terms qr-terms">
      <details className="qr-terms__acc" open>
        <summary className="qr-terms__summary">
          <span className="eyebrow">{block.props.heading ?? "Terms & conditions"}</span>
          <span className="qr-terms__chev" aria-hidden="true" />
        </summary>
        <div
          className="prose prose--small qr-terms__body"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </details>
    </section>
  );
}
